<div class="custom-menu-section themeBg" *ngIf="!partialLoggedIn">
    <div id="desktopMenu">
        <app-store-menu-list [user]="user" [isCustomerUser]="isCustomerUser"></app-store-menu-list>
    </div>
     
    <div class="hamburger-icon" id="mobileMenu" (click)="toggleMenu()">&#9776;</div>
</div>
<div class="mobile-menu-container" id="mobileMenuList" [ngClass]="{'open' : isMenuOpen}">
    <app-store-menu-list [user]="user" [isCustomerUser]="isCustomerUser"></app-store-menu-list>
</div>